import "twin.macro";

import { useMemo } from "react";
import { Outlet } from "react-router-dom";

import { usePermissions } from "./PermissionsContext";
import { FourOhOne } from "./routes/error/FourOhOne";
import { Permission } from "./utils/auth/Permission";

interface Props {
  permission: Permission;
}

const PermissionProtectedRoute = ({ permission }: Props) => {
  const { hasPermission } = usePermissions();
  const isAuthorized = useMemo(
    () => hasPermission(permission),
    [permission, hasPermission]
  );

  if (!isAuthorized) {
    return <FourOhOne />;
  }

  return <Outlet />;
};

export default PermissionProtectedRoute;
